import * as React from 'react';
import { SelectProps } from '../antd/Select/Select';
import styles from './CCSelect.module.scss';
import { CreditCard, BookingCreditCard, CCBrand } from 'app-types';
import classNames from 'classnames';
import { padStartTwoSymbolsZero } from 'utils/utils';

interface Props extends SelectProps {
	creditCard: BookingCreditCard | CreditCard;
}

export default class CCDisplay extends React.Component<Props> {
	render() {
		const { creditCard } = this.props;

		return (
			<div className={styles.ccDisplay}>
				<div
					className={classNames(
						styles.ccIcon,
						{ [styles[`cc-visa`]]: creditCard.brand === CCBrand.visa },
						{ [styles[`cc-masterCard`]]: creditCard.brand === CCBrand.masterCard },
						{ [styles[`cc-amex`]]: creditCard.brand === CCBrand.americanExpress },
						{ [styles[`cc-discover`]]: creditCard.brand === CCBrand.discover },
						{ [styles[`cc-diners`]]: creditCard.brand === CCBrand.dinersClub },
						{ [styles[`cc-jcb`]]: creditCard.brand === CCBrand.jcb },
						{ [styles[`cc-unionPay`]]: creditCard.brand === CCBrand.unionPay }
					)}
				/>
				<div className={classNames(styles.ccNumber)}>
					{creditCard.lastFourDigits}
					<span>
						{padStartTwoSymbolsZero(creditCard.expirationMonth)}/
						{creditCard.expirationYear}
					</span>
				</div>
			</div>
		);
	}
}
